import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Switch, Redirect } from "react-router-dom";
import moment from "moment";
import AuthRoute from "../AuthRoute";
import FullRoute from "../../Routing";
import LoginPage from "../LoginPage";
import { getHandshake } from "../../reducers/theme";
import "moment/locale/ar";

function App() {
  const dispatch = useDispatch();
  const [{ primary, secondary }, { locale, direction }] = useSelector(
    ({ theme, language }) => [theme, language]
  );

  useEffect(() => {
    dispatch(getHandshake());
    const html = document.documentElement;
    html.setAttribute("lang", locale);
  }, []);

  useEffect(() => {
    document.documentElement.style.setProperty("--primary-color", primary);
    document.documentElement.style.setProperty("--secondary-color", secondary);
    document.body.style.direction = direction;
    document.documentElement.style.direction = direction;
    moment.locale(locale);
  }, [primary, secondary, direction, locale]);

  return (
    <Switch>
      <Route path="/login" component={LoginPage} />
      <AuthRoute path="/" component={FullRoute} />
      <Redirect to={{ pathname: "/" }} />
    </Switch>
  );
}

export default App;
